import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-edit-file-modal',
  templateUrl: './edit-file-modal.component.html',
  styleUrls: ['./edit-file-modal.component.scss'],
})
export class EditFileModalComponent implements OnInit {
  @Input() uploadedFile: string;
  @Input() invalidFileType: any;
  @Input() selectedFileData: any;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Output() uploadFileEvent: EventEmitter<any> = new EventEmitter();
  uploadingFiles: ModalOptions;
  hideModal: boolean;
  incorrectFileFormat: boolean;
  hideModalOnRoute: any = false;
  problemUploadingFile: boolean;
  documentType = '';
  isAcmic = false;
  constructor(private acmicService: AcmicService) {
    this.hideModal = false;
    this.incorrectFileFormat = false;
    this.problemUploadingFile = false;
    this.isAcmic = this.acmicService.isACMIC();
    this.uploadingFiles = new ModalOptions({
      additionalClasses: 'modal-lg modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'editFileModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: this.isAcmic ? 'Edit file' : '',
      modalName: 'edit_files',
    });
  }
  ngOnInit(): void {
    this.documentType = this.selectedFileData.docType;
  }
  resetHideModal(event): void {
    if (event) {
      this.closeModal.emit(true);
    }
  }
  onCancel() {
    this.resetHideModal(true);
  }
  onSave() {
    this.selectedFileData.docType = this.documentType;
    this.uploadFileEvent.emit(this.selectedFileData);
    this.resetHideModal(true);
  }
}
